import Center from "../../assets/images/product/roofPro/center.webp";
import Left from "../../assets/images/product/roofPro/left.webp";
import RoofPro from "../../assets/images/products/roofPro.webp";
import { categoriesOfPaints } from "../categoryOfPaints";

export const roofPro = {
  category: [categoriesOfPaints.roofing],
  path: "festek_roof_pro",
  name: "FESTEK-ROOF PRO",
  header: "Краска кровельная акриловая «FESTEK-ROOF PRO»",
  link: "https://drive.google.com/file/d/1-7AvZuUXciO1ItPlD8ZSBiaFhV2BxHZe/view?usp=sharing",
  purchase: [
    {
      price: "140,00",
      amount: "15 кг",
    },
  ],
  productsPage: {
    title: "Кровельная «FESTEK-ROOF PRO»",
    text: "Глянцевая влагозащитная светостойкая краска для крыши и цоколя предотвращает образование плесени и грибка, улучшает сток воды",
  },
  images: {
    products: RoofPro,
    product: [Center, Left],
  },
  documentation: {
    description: {
      concept: {
        value:
          "это высокополимерная полуглянцевая кровельная краска. Которая образует пластичную пленку как резина. Краска отлично укрывает и смачивает подложку.",
        label: "FESTEK-ROOF PRO",
      },

      properties: {
        value: [
          "Имеет крайне высокую адгезию, отталкивает воду.",
          "Препятствует пылению покрытия, улучшает сток воды.",
          "Образует паропроницаемое «дышащее» покрытие с низким водопоглощением и хорошей адгезией отталкивает воду.",
          "Образованное покрытие устойчиво к разрушающему воздействию УФ-лучей, атмосферных осадков, перепадов температур.",
          "Обладает высокой укрывистостью.",
          "Содержит высокоэффективные биоциды, обеспечивающие устойчивость окрашенной поверхности к поражению мхом, плесневыми грибками и бактериями.",
          "Светостойкие пигменты в составе краски на протяжении длительного времени препятствуют выгоранию покрытия.",
        ],
        label: "Преимущество",
        note: [
          "* Прогнозируемый срок службы покрытия при соблюдении технологии нанесения – не менее 10 лет.",
        ],
      },

      consumption: {
        value:
          "На двухслойное покрытие – 350 - 400 г/м2, 800-1000 г на стандартный лист шифера. Зависит от состояния и подготовки поверхности, применяемого оборудования, квалификации работника и более точно определяется путем нанесения пробного покрытия.",
        label: "Расход",
      },

      package: {
        value: "11 литров – 15 килограмм; 20 литров – 25 килограмм.",
        label: "Упаковка",
      },

      suitableSubstrates: {
        value:
          "Асбестоцементные листы (шифер), цементно-песчаная черепица, а также бетонные, кирпичные, оштукатуренные цоколи зданий, декоративного камня, бетонных заборов и др. поверхностей.",
        label: "Пригодные подложки",
      },

      coatingSystem: {
        value:
          "Для получения качественного покрытия и снижения расхода краски поверхность обработать грунтовкой «Festek-Grunt» для глубокого проникновения, исходя из рекомендаций по применению. Краска готова к применению. При необходимости допускается разбавление водой – не более 5 %, при безвоздушном нанесении - около 10 %",
        label: "Система покрытия",
      },

      colorSolutions: {
        value:
          "Цвет: вишня, красно коричневый, шоколад, коричневый. + цвета по большинству колеровочных системы. Возможен подбор цвета по вашему образцу. Богатую палитру цветов можете выбрать у нас сайте",
        label: "Цветовые решения",
      },
    },

    applicationTechnology: {
      composition: {
        value:
          "Водная дисперсия акриловых сополимеров, светостойкие пигменты, наполнители, функциональные добавки, вода.",
        label: "Состав",
      },

      preparationSurfaces: {
        value:
          "Поверхность очистить от пыли, грязи, разделительных жидкостей, меловых, известковых, непрочно держащихся и несовместимых покрытий (силикатные, масляные и др. ЛКМ). При наличии биопоражений и высолов, удалить их механически или при помощи моек высокого давления, и при необходимости обработать специальными составами. Новые бетонные поверхности окрашивать не ранее, чем через 28 дней, оштукатуренные – не ранее, чем через 7 дней после их естественного высыхания (или в соответствии с рекомендациями производителя). Поверхность новых асбестоцементных листов промыть водой и полностью высушить. Металлические детали (арматура, шляпки гвоздей и т.д.) должны быть предварительно покрыты антикоррозионными грунтовками.",
        label: "Подготовка поверхности",
      },

      methodAndConditionsDrawing: {
        value:
          "Работы проводить при температуре окружающего воздуха, краски и основания от 10 °С до 25 °С. Не допускается нанесение при неблагоприятных погодных условиях (дождь, туман, выпадение росы, сильный ветер более 10 м/с), на сильно нагретую поверхность, находящуюся под прямыми солнечными лучами. При проведении окрасочных работ влажность основания должна быть не более 8 %, влажность воздуха – не более 80 %. Краска готова к применению. При необходимости допускается разбавление водой – не более 5 % при нанесении валиком и около 10 % при безвоздушном нанесении. Перед применением краску тщательно перемешать и наносить на поверхность: •\u00A0Кистью; •\u00A0Валиком; •\u00A0Пневматическим или безвоздушным методом распыления; Краска одного цвета, но различных партий, может незначительно отличаться по тону. Для исключения разнооттеночности получаемого покрытия следует выбирать краску одной партии, смешивать необходимое количество материала различных партий в отдельной емкости, либо окрашивать участки поверхностей, не лежащие в одной зрительной плоскости.",
        label: "Способ и условия нанесения",
      },

      temperature: {
        value:
          "Промежуточная сушка каждого слоя в течение 4 ч при температуре (20±2) °С. При более низкой температуре и/или повышенной влажности время высыхания может увеличиваться до 24 ч. Время выдержки покрытия до первой влажной уборки – не менее 21 суток.",
        label: "Температурный режим, время высыхания",
      },

      endlessApplication: {
        value:
          'При нанесении краскопультом (безвоздушное) рекомендуются след. параметры: угол распыления 60°, диаметр сопла 0,53-0,58 мм (0,021"-0,023" дюйма), Давление 175-180 bar.',
        label: "Безвоздушное нанесение",
      },
    },

    technicalData: [
      {
        qualityIndicators: "Массовая доля нелетучих веществ, %",
        value: "52 - 62",
      },
      {
        qualityIndicators: "Показатель концентрации ионов водорода, рН",
        value: "7,5 - 9,5",
      },
      { qualityIndicators: "Степень перетира, мкм, не более", value: "70" },
      {
        qualityIndicators:
          "Время высыхания до степени 3 при температуре (20 ± 2) °С, ч, не более",
        value: "1",
      },
      {
        qualityIndicators:
          "Условная светостойкость покрытия за 24 ч (изменение коэффициента диффузного отражения),%, не более",
        value: "5",
      },
      {
        qualityIndicators: "Адгезия покрытия к основанию, МПа, не менее",
        value: "2,0",
      },
      {
        qualityIndicators:
          "Стойкость покрытия к статическому воздействию воды при температуре (20 ± 2) °С, ч, не менее",
        value: "24",
      },
      {
        qualityIndicators:
          "Коэффициент паропроницаемости, мг/(м ч Па), не менее",
        value: "0,015",
      },
      {
        qualityIndicators: "Морозостойкость покрытия, циклы, не менее",
        value: "50",
      },
      {
        qualityIndicators:
          "Стойкость покрытия к воздействию климатических факторов, циклы, не менее",
        value: "120",
      },
      {
        qualityIndicators:
          "Срок службы покрытия в условиях эксплуатации У1, лет, не менее",
        value: "10",
      },
    ],
  },
};
